"use client";

import React, { useMemo } from "react";
import { InvestmentOptions } from "@/app/interface/platform";
import Home from "@/app/assets/icons/home";
import Refer from "@/app/assets/icons/refer";
// import Learn from "@/app/assets/icons/learn";
import Fingerprint from "@/app/assets/icons/finerprint";
import PortfolioIcon from "@/app/assets/icons/portfolio-icon";
// import Media from "@/app/assets/icons/media";
import type { NavItem } from "@/types/nav-item.types";
import { DirectPaths } from "@/config/routes";
import Bullion from "../assets/icons/bullion";
import Learn from "../assets/icons/learn";
// import Diamond from "../assets/icons/diamond";

interface Props {
    active: string;
    isLoggedIn: boolean;
}

/* const emptyObject: NavItem = {
    label: "",
    href: "",
    eventName: "",
    branchEvent: "",
    isActive: false,
    isExternal: false,
    logoUrl: ``,
    icon: null,
}; */

const useNavItems = ({ active, isLoggedIn }: Props): NavItem[] => {
    return useMemo(
        () => [
            {
                label: InvestmentOptions.Home,
                href: isLoggedIn
                    ? String(`${process.env.ICM_POST_URL}`)
                    : String(process.env.ICM_URL),
                isActive: Boolean(active === InvestmentOptions.Home),
                isExternal: false,
                icon: <Home />,
            },
            {
                label: process.env.SHOW_BULLION === "true" ? InvestmentOptions.Gold : "",
                href:
                    (isLoggedIn
                        ? `${process.env.ICM_BULLION_POST_URL}`
                        : `${process.env.ICM_BULLION_URL}`) +
                        `${DirectPaths.BULLION_POSTFIX_PATH + DirectPaths.GOLD}` || "",
                isActive: Boolean(active === InvestmentOptions.Gold),
                branchEvent: "Navigation_Bullion",
                isExternal: false,
                isNew: true,
                logoUrl: `${process.env.ICM_BULLION_LOGO_URL}`,
                icon: <Bullion className="h-full w-full" />,
            },
            {
                label: isLoggedIn ? InvestmentOptions.Portfolio : "",
                href: `${process.env.ICM_URL}/portfolio`,
                branchEvent: "Navigation_Portfolio",
                isActive: Boolean(active === InvestmentOptions.Portfolio),
                isExternal: false,
                icon: <PortfolioIcon />,
            },
            {
                label: InvestmentOptions.Refer,
                href: `${process.env.ICM_URL}/refer`,
                eventName: "Refer_Homepage_Top_Nav_bar",
                branchEvent: "Navigation_Refer",
                isActive: Boolean(active === InvestmentOptions.Refer),
                isExternal: false,
                icon: <Refer />,
            },
            {
                label: "About",
                href: `${process.env.ICM_URL}/about`,
                eventName: "Home_Nav_Bar_About_Us",
                isActive: Boolean(active === "About"),
                isExternal: false,
                icon: <Fingerprint />,
            },
            {
                label: "Blogs",
                href: `${process.env.ICU_LEARN}`,
                branchEvent: "Navigation_Blogs",
                isActive: false,
                isExternal: true,
                icon: <Learn />,
            }
            /* {
                label: "Media",
                href: `${process.env.ICM_MEDIA}`,
                eventName: "Home_Nav_Bar_Media",
                isActive: false,
                isExternal: false,
                icon: <Media />,
            }, */
        ],
        [isLoggedIn, active],
    );
};

export default useNavItems;
